import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type SubjectFieldDefinitionDraftPayload = {
	readonly key: string;
	readonly label: string;
	readonly nature: LabeledValuePayload;
	readonly options: readonly LabeledValuePayload[];
	readonly required: boolean;
	readonly sentToAi: boolean;
	readonly archived: boolean;
};

export type SubjectTypeGrantPayload = {
	readonly kind: 'role' | 'user';
	readonly id: number;
	readonly level: LabeledValuePayload;
};

export type SubjectTypeDefinitionPayload = {
	readonly id: number;
	readonly key: string;
	readonly archivedAt: string | null;
	readonly isUsed: boolean;
	readonly wording: {
		readonly singular: string;
		readonly plural: string;
		readonly createAction: string;
		readonly emptyList: string;
		readonly sheetTitle: string | null;
		readonly aboutLabel: string;
		readonly titleLabel: string;
	};
	readonly icon: LabeledValuePayload;
	readonly color: LabeledValuePayload;
	readonly informationMode: LabeledValuePayload;
	readonly membersCanShare: boolean;
	readonly about: readonly LabeledValuePayload[];
	readonly fields: readonly SubjectFieldDefinitionDraftPayload[];
	readonly speakerRoles: readonly { readonly key: string; readonly label: string }[];
	readonly usableBy: readonly SubjectTypeGrantPayload[];
	readonly workflowKeys: readonly string[];
};

export type SubjectTypeDefinitionsFetchedPayload = SubjectTypeDefinitionPayload[];

export type SubjectTypeDefinitionsFetchedAction = {
	type: 'SUBJECT_TYPE_DEFINITIONS_FETCHED';
	payload: SubjectTypeDefinitionsFetchedPayload;
	accountId: number;
};

export default (
	payload: SubjectTypeDefinitionsFetchedPayload,
	accountId: number,
): SubjectTypeDefinitionsFetchedAction => ({
	type: 'SUBJECT_TYPE_DEFINITIONS_FETCHED',
	payload,
	accountId,
});
